export default "__VITE_ASSET__Hsge3H4k__"